export default __webpack_public_path__ + "static/media/element_spec_58.5d968436.jpg";